export const environment = {
  version: "2.26.275.1",
  backendUrl: "https://api.phish.beta.pulsarsecurity.com/v1",
  redirect_uri: "https://phishing-beta-pulsarsecurity.phish.beta.pulsarsecurity.com",
  msalConfig: {
    auth: {
      clientId: '9fbd097b-64e6-4c75-beb6-b7dd697c7a84', //Pulsar Security Tenant
      authority: 'https://login.microsoftonline.com/common'
    }
  },
  apiConfig: {
    scopes: ["User.Read", "openid", "profile", "Mail.Read", "offline_access", "email",
      'Contacts.Read', 'Group.Read.All', "Mail.Send", 'Mail.Read.Shared', 'Mail.ReadWrite.Shared', 'Mail.Send.Shared'],
    alter_inbox_scope: ["Mail.ReadWrite"],
    microsoft_graph_url_personal: 'https://graph.microsoft.com/v1.0/me',
    microsoft_graph_url: 'https://graph.microsoft.com/v1.0',
  }
};
